import _Indexes from './Indexes';
import _IndexesAnchor from './IndexesAnchor';

import './style';

export type { IndexesProps } from './Indexes';
export type { IndexesAnchorProps } from './IndexesAnchor';

export * from './type';

export const Indexes = _Indexes;
export const IndexesAnchor = _IndexesAnchor;

export default Indexes;
